
import { GoogleGenAI } from "@google/genai";

export const generateAIResponse = async (
  prompt: string, 
  language: 'en' | 'cn',
  history: { role: 'user' | 'model'; text: string }[]
): Promise<string> => {
  // Use the environment variable directly as per guidelines
  const apiKey = process.env.API_KEY;

  if (!apiKey) {
    console.error("API_KEY is missing. Ensure you have a .env file with API_KEY=your_key and have restarted your dev server.");
    return language === 'en' 
      ? "AI service is currently misconfigured (Missing API Key). Please contact support." 
      : "AI 服务配置错误（缺少 API Key）。请联系客服。";
  }

  try {
    // Initialize GoogleGenAI with the required named parameter
    const ai = new GoogleGenAI({ apiKey });

    const systemInstruction = `You are a helpful and professional sales assistant for a cloud reselling website called "CloudResell Pro". 
    Your goal is to assist users in choosing cloud providers (AWS, Azure, GCP, Cloudflare, Aliyun, Tencent, Huawei, Volcengine) and explain our benefits.
    
    Key Selling Points:
    - Up to 40% discount on official prices.
    - No KYC (Know Your Customer) required. Privacy focused.
    - Accept USDT and BTC payments.
    - High security enterprise accounts.
    - Instant delivery via Telegram support (@cloudresell_demo).

    Language: Respond in ${language === 'en' ? 'English' : 'Chinese'}.
    Tone: Professional, persuasive, concise, and helpful.
    Do not invent fake prices. Refer to "contact support for specific pricing".
    `;
    
    // Using gemini-3-flash-preview for general text tasks
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: [
        ...history.map(h => ({
          role: h.role === 'user' ? 'user' : 'model',
          parts: [{ text: h.text }]
        })),
        { role: 'user', parts: [{ text: prompt }] }
      ],
      config: {
        systemInstruction: systemInstruction,
      },
    });

    return response.text || (language === 'en' ? "I couldn't generate a response." : "无法生成回复。");

  } catch (error) {
    console.error("Gemini API Error:", error);
    return language === 'en' 
      ? "Sorry, I encountered an error connecting to the AI. Please try again or contact us directly." 
      : "抱歉，连接 AI 时遇到错误。请稍后再试或直接联系我们。";
  }
};

